import { FieldOption, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";

import { Card, CompartmentCard } from "@/src/components/cards";

import { FolderItem, Metastasis } from "@/src/data/allTypes";

import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { UploadCards } from "@/src/components/uploadSpots";
import { getUserId, uid } from "@/src/utils/utils";
import moment from "moment";
import {
  RefAnswerForm,
  ReferenceFieldsForm,
} from "../fields/referenceFieldsForm";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import { ReferenceChoiceList } from "../admin/referentiel/referenceChoiceList";
import { openSnomedConceptPicker } from "../snomed/SnomedConceptPicker";
import { AntecedentsCard } from "../patients/antecedentsCard";
import { FieldAnswersList } from "../fields/fieldsAnswersList";

function MetastasisCompartment({
  patient,
  parent,
}: {
  patient: Patient;
  parent: FolderItem;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");

  async function openFieldsFormDrawer(metastasis: Metastasis) {
    let reference = metastasis.reference;
    if (!reference) {
      throw new Error("No reference in patientItem");
    }
    metastasis.content ||= {
      patient: patient,
      reference: reference,
      fieldAnswers: [],
      creator: getUserId(),
    };
    await openDrawer({
      title: `${reference.name}`,
      content: (
        <RefAnswerForm
          patient={patient}
          refAnswer={metastasis.content}
          onChange={(newPatientsReference) => {
            metastasis.content = newPatientsReference;
          }}
        ></RefAnswerForm>
      ),
      onConfirm: async () => {
        await apiFetch(
          "metastasis",
          "addOne",
          { metastasis },
          "Erreur lors de la sauvegarde de la métastase"
        );
        setReload((prev) => prev + 1);
      },
    });
  }

  return (
    <CompartmentCard
      title={"Métastases"}
      onClick={async () => {
        await openSnomedConceptPicker({
          title: "Choisir un diagnostic",
          parentIds: ["metastasis"],
          category: "diagnostic",
          onSelect: async (reference) => {
            let metastasis: Metastasis = {
              type: "metastasis",
              creator: getUserId(),
              patient: patient,
              reference,
              parent,
              notes: "",
              conclusion: "",
              confidentiality: getStandardConfidentiality(patient),
              readBy: [getUserId()],
              content: {
                patient: patient,
                reference: reference,
                fieldAnswers: [],
                creator: getUserId(),
              },
            };

            await openFieldsFormDrawer(metastasis);
            closeDrawer("metastasisChoiceDialog");
          },
        });

        // await openDrawer({
        //   id: "metastasisChoiceDialog",
        //   title: "Choisir une métastase",
        //   content: (
        //     <ReferenceChoiceList
        //       current={[]}
        //       categories={["metastasis"]}
        //       onSelect={async (reference) => {
        //         let metastasis: Metastasis = {
        //           type: "metastasis",
        //           creator: getUserId(),
        //           patient: patient,
        //           reference,
        //           parent,
        //           notes: "",
        //           conclusion: "",
        //           confidentiality: getStandardConfidentiality(patient),
        //           readBy: [getUserId()],
        //           content: {
        //             patient: patient,
        //             reference: reference,
        //             fieldAnswers: [],
        //             creator: getUserId(),
        //           },
        //         };

        //         await openFieldsFormDrawer(metastasis);
        //         closeDrawer("metastasisChoiceDialog");
        //       }}
        //     />
        //   ),
        // });
      }}
    >
      <FetchableList
        queryKey={["MetastasisCompartment", searchKey, patient.id, reload]}
        queryFn={() =>
          apiFetch("metastasis", "loadMany", {
            patientId: patient.id,
            parentId: parent.id,
          })
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((metastasis) => {
              return (
                <MetastasisTile
                  key={uid()}
                  item={metastasis}
                  onClick={async () => {
                    await openFieldsFormDrawer(metastasis);
                  }}
                  onDelete={async () => {
                    await apiFetch(
                      "general",
                      "deleteAny",
                      {
                        table: "metastasis",
                        id: metastasis.id,
                      },
                      "Erreur lors de la suppression de la métastase"
                    );
                    setReload((prev) => prev + 1);
                  }}
                ></MetastasisTile>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}

function MetastasisTile({
  item,
  onClick,
  onDelete,
}: {
  item: Metastasis;
  onDelete?: () => void;
  onClick: () => void;
}) {
  let reference = item?.reference;

  return (
    <Card
      key={uid()}
      color="blue"
      onClick={async (e) => {
        e.stopPropagation();
        onClick();
      }}
      onDelete={async () => {
        onDelete?.();
      }}
    >
      <div className="bold main-color">{reference?.name}</div>
      <div className="bold">Dr {item?.creator?.lastName}</div>

      {item.content?.notes != null ? (
        <div className="">{item.content?.notes}</div>
      ) : null}

      {item.conclusion ? <div className="bold">{item.conclusion}</div> : null}
      {item.content?.fieldAnswers?.length != 0 && (
        <FieldAnswersList
          patient={item.patient}
          reference={item.reference}
          answers={item.content?.fieldAnswers || []}
        ></FieldAnswersList>
      )}
      <div className="gray">{moment(item?._date).format("LL HH:mm")}</div>

      <UploadCards uploads={item.uploads} />
    </Card>
  );
}

export { MetastasisCompartment };
